import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { StateService } from '../../state/state.service';
import { AddKaskoCustomerTypeCommand } from '../../state/kasko/kasko-commands';

@Component({
  selector: 'app-modal-client-type',
  templateUrl: './modal-client-type.component.html',
  styleUrls: ['./modal-client-type.component.scss']
})
export class ModalClientTypeComponent {

  isProcessing = false;

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
    private state: StateService,
  ) { }

  closeModal() {
    this.activeModal.close();
  }

  goToCustomerDetails(type) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    this.state.execute(new AddKaskoCustomerTypeCommand(type));
    this.router.navigate(['shop', 'kasko-new', 'customer-details']);
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/kasko-new/modal-client-type/modal-client-type.component.ts